import React from "react";
import { TestiMonials } from "./Containt_home";


const Language = ()=>{
    return <div>
    <h1>Language</h1>
     <TestiMonials />;
    </div>
}
export default Language;